export default __webpack_public_path__ + "cf51e4d26fbe5a98772206890be6730d.svg";